import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import type { TextStyle } from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './ReviewProviders.module.scss';

import { usePartners } from '@hotels-hotel-detail/data-access/hooks/useHotelReviewsContext';
import { FormattedMessage } from '@shared/ui/components/i18n';

const cls = cssModules(STYLES);
type Props = {
  textStyle?: TextStyle;
  height?: number;
};

const ReviewProviders = ({
  height = 30,
  textStyle = TEXT_STYLES.heading3,
}: Props) => {
  const partners = usePartners();

  if (!partners) {
    return null;
  }

  return (
    <BpkText
      textStyle={textStyle}
      tagName="p"
      className={cls('ReviewProviders__title')}
    >
      <FormattedMessage
        label="hotel_review_from_data_source"
        data={{
          ta_logo: (
            <div className={cls('ReviewProviders__logos')}>
              {partners.map(({ circleLogo, id, name }) => (
                <img key={id} src={circleLogo} height={height} alt={name} />
              ))}
            </div>
          ),
          trip_logo: null,
        }}
        startTag="<"
        endTag=">"
      />
    </BpkText>
  );
};

export default ReviewProviders;
